import type { ContactVerificationStatus } from '@simplemon/lib';
import { Badge } from '@/components/ui/badge';

interface ContactStatusBadgeProps {
  status: ContactVerificationStatus;
}

export function ContactStatusBadge({ status }: ContactStatusBadgeProps) {
  const variants: Record<
    ContactVerificationStatus,
    { variant: 'default' | 'secondary' | 'success' | 'warning'; label: string }
  > = {
    not_verified: { variant: 'secondary', label: 'Not Verified' },
    requested: { variant: 'warning', label: 'Verification Requested' },
    verified: { variant: 'success', label: 'Verified' },
  };

  const { variant, label } = variants[status];

  return <Badge variant={variant}>{label}</Badge>;
}
